/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon16Solid = forwardRef('ShapeTriangleUpIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m.755 10.911 5.568-8.577a2 2 0 0 1 3.355 0l5.567 8.577c.864 1.33-.091 3.09-1.678 3.09H2.433C.846 14-.11 12.24.755 10.91Z" })));
});
